import React, { useEffect } from "react"; 
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1400px; 
  margin: 0 auto;
  padding: 40px 24px;
  box-sizing: border-box;
  background-color: #ffffff;
`;

const MasonryContainer = styled.div`
  /* 2 Columns for Desktop, 1 for Mobile */
  column-count: 2;
  column-gap: 30px;

  @media (max-width: 768px) {
    column-count: 1;
    column-gap: 0;
  }
`;

const Item = styled.div`
  break-inside: avoid;
  display: block; 
  width: 100%;
  margin-bottom: 30px; 
  border-radius: 12px;
  overflow: hidden;
  background: #f9f9f9; 
  border: 1px solid #efefef;
  animation: ${fadeIn} 0.6s ease forwards;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  color: transparent; 
  text-indent: -10000px; 
  transition: transform 0.5s ease;

  ${Item}:hover & {
    transform: scale(1.02);
  }
`;

const Gallery = () => {
  const allImages = [
    "gal.png", "pp.jpeg", "GalImg1.jpg", "GalImg2.jpg", "GalImg3.jpg",
    "c1n1.jpg", "c1n2.jpg", "c1n3.jpg", "c1n4.jpg", "c1n5.jpg", "c1n6.jpg",
    "c2n1.jpg", "c2n2.jpg", "c2n3.jpg", "c2n4.jpg", "c2n5.jpg",
    "c3n1.jpg", "c3n2.jpg", "c3n3.jpg", "c3n4.jpg", "c3n5.jpg", "c3n6.jpg", "c3n7.jpg",
    "c4n1.jpg", "c4n2.jpg", "c4n3.jpg", "c4n4.jpg", "c4n5.jpg", "c4n6.jpg",
    "s1.jpeg", "s2.jpeg", "s3.jpeg", "s4.jpeg"
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <Wrapper>
      <MasonryContainer>
        {allImages.map((imgName, i) => (
          <Item key={i} style={{ animationDelay: `${i * 0.05}s` }}>
            <Img
              src={`/images/gallery/${imgName}`}
              alt="" 
              loading="lazy"
            />
          </Item>
        ))}
      </MasonryContainer>
    </Wrapper>
  );
};

export default Gallery;
            